<template>
  <b-col cols="12">
    <b-form-group label="Escolha o pacote">
      <validation-provider
        #default="{ errors }"
        rules="required"
        name="Escolha o pacote"
      >
        <v-select
          v-model="value_"
          :options="pacotes"
          label="nome"
          :clearable="false"
          @input="enviarParaPai"
        >
          <template #selected-option="{ nome, acrescimoPacote, descontoPacote, valorPacote }">
            <span>{{ nome }} - {{ getValorTotalPacote({acrescimoPacote: acrescimoPacote, descontoPacote: descontoPacote, valorPacote: valorPacote}) }}</span>
          </template>
          <template v-slot:option="option">
            <span>{{ option.nome }} - {{ getValorTotalPacote(option) }}</span>
          </template>
        </v-select>
        <small
          v-if="errors[0]"
          class="text-danger"
        >O campo escolha do pacote é obrigatório</small>
      </validation-provider>
    </b-form-group>
  </b-col>
</template>

<script>
import vSelect from 'vue-select'
import { ValidationProvider } from 'vee-validate'

export default {
  name: 'PacoteStatus',
  components: {
    vSelect,
    ValidationProvider,
  },
  props: {
    value: {
      type: Object,
      default: null,
    },
    pacotes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      valueInner: null,
    }
  },
  computed: {
    value_: {
      get() {
        return this.valueInner ? this.valueInner : this.value
      },
      set(newValue) {
        this.valueInner = newValue
        return this.valueInner
      },
    },
  },
  watch: {
    value(value, oldValue) {
      if (value !== oldValue) {
        this.valueInner = value
      }
    },
  },
  /* eslint no-underscore-dangle: 0 */
  methods: {
    getValorTotalPacote(option) {
      let valor = option.valorPacote
      if (this.tipoAcresDesc === '%') {
        if (typeof option.acrescimoPacote === 'string') {
          valor += ((parseFloat(option.acrescimoPacote.replace('%', ''), 10) / 100) * valor)
        }
        if (typeof option.descontoPacote === 'string') {
          valor -= ((parseFloat(option.descontoPacote.replace('%', ''), 10) / 100) * valor)
        }
      } else {
        valor += option.acrescimoPacote || 0
        valor -= option.descontoPacote || 0
      }
      return valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },
    enviarParaPai() {
      this.$emit('select', !this.value_ ? null : this.value_)
      this.$emit('input', !this.value_ ? null : this.value_)
    },
  },
}
</script>
